import PropTypes from 'prop-types'
import { Th, Td } from '@chakra-ui/react'

export const ThMetric = ({ children, ...rest }) => {
  return (
    <Th
      fontSize="xs"
      borderColor="gray.200"
      borderStyle="solid"
      borderWidth={1}
      textAlign="center"
      {...rest}
    >
      {children}
    </Th>
  )
}

ThMetric.propTypes = {
  children: PropTypes.node
}

export const TdMetric = ({ children, ...rest }) => {
  return (
    <Td
      py={2}
      fontSize="sm"
      borderColor="gray.200"
      borderStyle="solid"
      borderWidth={1}
      textAlign="center"
      {...rest}
    >
      {children}
    </Td>
  )
}

TdMetric.propTypes = {
  children: PropTypes.node
}
